<template>
  <div>
    <v-autocomplete
        v-model="defaultModel"
        :items="external_data_items"
        :id="control.uniqueId"
        :class="controlFieldClass"
        :name="control.name || control.uniqueId"
        @input="updateValue(computeCurrentValue)"
        :item-text="`${control.field_text}`"
        :item-value="control.field_value"
        :key="`autocomplete-${control.field_value}`"
        :hint="computeHintValue"
        :disabled="isDisabled"
        :search-input.sync="search"
        :loading="loading"
        :no-filter="true"
        persistent-hint
        class="v-input--hide-details"
        dense
        return-object
        chips
        solo
    ></v-autocomplete>
  </div>
</template>

<script>
import {BaseControlSkeleton} from 'v-form-builder';
import {readUserProfile} from '@/store/main/getters';
import {api} from '@/helpers/api';

export default {
  name: 'DropdownControl',
  extends: BaseControlSkeleton,
  data: () => ({
    defaultModel: null,
    external_data_items: [],
    dd_text: '',
    dd_value: '',
    isDisabled: false,
    loading: false,
    search: '',
    searchTimer: null,
  }),

  computed: {
    computeCurrentValue() {
      if (this.defaultModel) {
        return this.defaultModel[this.control.field_value];
      }
      return null;
    },
    computeHintValue() {
      if (this.defaultModel && this.control.field_hint) {
        return `${this.defaultModel[this.control.field_hint]}`;
      }
      return '';
    },
  },

  methods: {
    resolveValue(value) {
      if (value && typeof value === 'object') {
        return value[this.control.field_value];
      }
      return value;
    },
    hasValue(value) {
      return value !== null && value !== undefined && value !== '';
    },
    sameItemValue(a, b) {
      return this.hasValue(a) && this.hasValue(b) && String(a) === String(b);
    },
    prependSelectedItem(items) {
      if (!this.defaultModel || !this.control.field_value) {
        return items;
      }
      const selectedValue = this.defaultModel[this.control.field_value];
      if (items.some((item) => this.sameItemValue(item[this.control.field_value], selectedValue))) {
        return items;
      }
      return [this.defaultModel].concat(items);
    },
    async fetchItems(q = '') {
      if (!this.control.external_data_id || this.control.external_data_id <= 0) {
        return;
      }
      this.loading = true;
      try {
        const response = await api.getExternalDataRows(this.control.external_data_id, {
          skip: 0,
          limit: 25,
          q,
          field: this.control.field_text || this.control.field_value,
        });
        this.external_data_items = this.prependSelectedItem(response.data.items.map((item) => item.value));
      } finally {
        this.loading = false;
      }
    },
    async loadSelectedValue(value) {
      const selectedValue = this.resolveValue(value);
      if (!this.hasValue(selectedValue) || !this.control.field_value || !this.control.external_data_id) {
        return;
      }
      if (this.defaultModel && this.sameItemValue(this.defaultModel[this.control.field_value], selectedValue)) {
        return;
      }
      const existingItem = this.external_data_items.find((item) =>
        this.sameItemValue(item[this.control.field_value], selectedValue));
      if (existingItem) {
        this.defaultModel = existingItem;
        return;
      }
      const response = await api.lookupExternalDataRow(this.control.external_data_id, this.control.field_value, selectedValue);
      const item = response.data.items.length > 0 ? response.data.items[0].value : null;
      if (item) {
        this.defaultModel = item;
        if (!this.external_data_items.some((e) => e[this.control.field_value] === item[this.control.field_value])) {
          this.external_data_items = [item].concat(this.external_data_items);
        }
      }
    },
  },

  async mounted() {
    if (this.control.disableByRoleSetting) {
      const userProfile = readUserProfile(this.$store);
      this.isDisabled =
          !(userProfile?.role?.settings?.permissions?.can_edit_control_field?.methods?.can_edit_control_field);
    } else if (this.control.isDisabled) {
      this.isDisabled = true;
    }

    if (this.isDisabled) {
      return;
    }

    if (this.control.external_data_id > 0) {
      await this.fetchItems();
      await this.loadSelectedValue(this.value);
    }

    // if (!this.value) {
    //   await Promise.all([
    //     await new Promise((resolve, reject) => setTimeout(() => resolve(), 500)),
    //     this.updateValue(this.value),
    //     this.defaultModel = this.value,
    //   ]);
    // }
  },

  watch: {
    value: {
      async handler(cv, ov) {
        if (!this.defaultModel) {
          await this.loadSelectedValue(cv);
        }
      },
      deep: true,
    },
    search(val) {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => this.fetchItems(val || ''), 300);
    },
  },
};
</script>

<style scoped>

</style>
